import script from "./NewModalPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewModalPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewModalPopup.vue?vue&type=style&index=0&id=34bf300e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bf300e"]])

export default __exports__